import React from "react";
import { useTranslation } from 'react-i18next';

type MapMode = '2d' | '3d';

interface MapModeToggleProps {
  mode: MapMode;
  onModeChange: (mode: MapMode) => void;
  isAhp: boolean;
  is3dLoading?: boolean;
}

export function MapModeToggle({ mode, onModeChange, isAhp, is3dLoading }: MapModeToggleProps) {
  const { t } = useTranslation('map');
  const activeStyle = isAhp
    ? { backgroundColor: '#002868', color: '#fff', borderColor: '#C5A55A' }
    : { backgroundColor: '#00ff03', color: '#000', borderColor: '#00ff03' };

  const inactiveStyle = isAhp
    ? { backgroundColor: 'rgba(0,40,104,0.3)', color: '#ccc', borderColor: 'rgba(197,165,90,0.3)' }
    : { backgroundColor: 'rgba(0,0,0,0.6)', color: '#888', borderColor: 'rgba(0,255,3,0.3)' };

  return (
    // Below lg the 600px right panel is hidden, so right:620px would push the
    // toggle off-screen — hug the right edge instead (below the mobile chrome).
    <div className="absolute top-16 right-4 lg:top-4 lg:right-[620px] z-[60] flex rounded-lg overflow-hidden shadow-lg">
      <button
        onClick={() => onModeChange('2d')}
        style={{
          ...(mode === '2d' ? activeStyle : inactiveStyle),
          padding: '6px 14px',
          fontSize: '13px',
          fontWeight: 600,
          border: '1px solid',
          borderRight: 'none',
          borderRadius: '6px 0 0 6px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          letterSpacing: '0.5px',
        }}
      >
        {t('mapMode.mode2d')}
      </button>
      <button
        onClick={() => onModeChange('3d')}
        disabled={is3dLoading}
        style={{
          ...(mode === '3d' ? activeStyle : inactiveStyle),
          padding: '6px 14px',
          fontSize: '13px',
          fontWeight: 600,
          border: '1px solid',
          borderLeft: 'none',
          borderRadius: '0 6px 6px 0',
          cursor: is3dLoading ? 'wait' : 'pointer',
          transition: 'all 0.2s ease',
          letterSpacing: '0.5px',
          opacity: is3dLoading ? 0.6 : 1,
        }}
      >
        {is3dLoading ? t('mapMode.loading3d') : t('mapMode.mode3d')}
      </button>
    </div>
  );
}
